// extracted by mini-css-extract-plugin
export var baseButton = "_pb-0";
export var controlsArrowKeys = "_pb-1";
export var controlsResetButton = "_pb-2";
export var lightGameButton = "_pb-4 _pb-0";
export var playAgainButton = "_pb-5 _pb-0";
export var startGameButton = "_pb-3 _pb-0";